export default {
  "HitPaw Add Music to Audio Online": "為音訊添加音樂",
  "Add BGM to Audio without any difficulties.": "無壓力的為音訊添加背景音樂",
  "Add New": "編輯新的音訊",
  "Format": "格式",
  "Add tracks": "添加軌道",

};
